import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { getBasicIconGroup } from '../../../../../services/getBasicIcon';
import {
    FacilityWithGroupId,
    HotelBasicFacilityGroups,
} from '../../../../models/hotel-info';
import { ComponentJSSClasses } from './styles';

export interface BasicFacilitiesProps {
    facilities: FacilityWithGroupId[];
}

interface StyledBasicFacilitiesProps
    extends BasicFacilitiesProps,
        JSSClassesProps<ComponentJSSClasses> {}

export class BasicFacilities extends React.Component<
    StyledBasicFacilitiesProps,
    {}
> {
    render() {
        const { classes } = this.props;

        return (
            <div className={classes.container}>
                {this.props.facilities.map((facility) =>
                    this.renderFacilityItem(facility)
                )}
            </div>
        );
    }

    renderFacilityItem(facility: FacilityWithGroupId) {
        const { classes } = this.props;

        return (
            <div className={classes.facilityItem} key={facility.id}>
                <div className={classes.iconWrapper}>
                    {getBasicIconGroup(
                        HotelBasicFacilityGroups[
                            HotelBasicFacilityGroups[
                                facility.groupId
                            ] as unknown as number
                        ] as unknown as HotelBasicFacilityGroups
                    )}
                </div>
                <div className={classes.textWrapper}>
                    <p className={classes.label}>{facility.name}</p>
                    {facility.secondName && <p className={classes.label}>{facility.secondName}</p>}
                </div>
            </div>
        );
    }
}
